
export default {
    name: 'DisplayContractor',
    props: {
        value: {
            type: Object,
            required: true,
        },
        searchTerm: {
            type: String,
        },
    },
    computed: {
        contractor() {
            if (this.value.displayContractor) {
                return {
                    path:
                        this.value.displayContractor.namePath.length > 1
                            ? this.value.displayContractor.namePath.join(' → ')
                            : '',
                    name: this.value.displayContractor.namePath[
                        this.value.displayContractor.namePath.length - 1
                    ],
                }
            }
            return { path: '', name: '' }
        },
    },
}
